import { Accordion } from 'shared/components/Accordion/Accordion'
import { FlexBox } from 'shared/components/Base/Base'
import { Toggle } from 'shared/components/Checkbox/Toggle'
import { Text } from 'shared/components/Text/Text'
import { SafetyEvent } from 'shared/models/compliance'
import { darkGray, informationL1 } from 'shared/theme/colors'
import styled from 'styled-components'

import { SafetyEventViolationAccordionDetails } from './SafetyEventAccordionDetails'

interface SafetyEventAccordionProps {
  safetyEvent: SafetyEvent
  isExpanded: boolean
}

export function SafetyEventAccordion({ safetyEvent, isExpanded }: SafetyEventAccordionProps) {
  // TODO: @public-enhanced-safety-tool remove undefined check after backend is updated
  const showContribution =
    safetyEvent.remainingPoints !== null &&
    safetyEvent.remainingPoints !== undefined &&
    safetyEvent.originalPoints !== null &&
    safetyEvent.originalPoints !== undefined

  return (
    <Accordion
      isExpanded={isExpanded}
      details={
        <ExpandedContainer isColumn>
          <SafetyEventViolationAccordionDetails safetyEvent={safetyEvent} />

          {showContribution && (
            <FlexBox mt={3}>
              <Text variant="paragraph2" fontColor={darkGray} mr={1}>
                Contributes to the safety score
              </Text>
              <StyledToggle value={!!safetyEvent.remainingPoints} />
            </FlexBox>
          )}
        </ExpandedContainer>
      }
      hideExpandIcon
    >
      {() => <></>}
    </Accordion>
  )
}

const ExpandedContainer = styled(FlexBox)`
  padding: 24px 24px 24px 146px;
  background-color: ${informationL1};
`

// TODO: style the toggle further
const StyledToggle = styled(Toggle)``
